module.exports = __webpack_public_path__ + "static/humans_waterdhavian-49f0c13c57bd5c16071f9db552c62e63.webp";